import styled from "styled-components";

import { Icon } from "@formant/ui/component/common/Icon";

import { Avatar } from "../../common/Avatar";
import styles from "../LinkListItem.scss";
import { Section } from "../Section";

export const TeleopListSection = styled(Section)`
    overflow: hidden;
    overflow-y: auto;

    /* FIXME class-specificity battle. 
     *  unroll this when LinkListItem is updated to styled-components */
    .${styles.button} {
        padding: 0.625rem 1.25rem;
        &:hover {
            color: white;
        }
    }
`;

export const TeleopIcon = styled(Icon).attrs(() => ({
    size: "18",
}))`
    margin-top: 0.125rem;
`;

export const TeleopAvatar = styled(Avatar).attrs(() => ({
    light: true,
}))``;
